// extracted by mini-css-extract-plugin
export var errorIcon = "_os-1";
export var nameLogo = "_os-0";